import { render, staticRenderFns } from "./InfoTitle.vue?vue&type=template&id=3b74c468&"
import script from "./InfoTitle.vue?vue&type=script&lang=js&"
export * from "./InfoTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b74c468')) {
      api.createRecord('3b74c468', component.options)
    } else {
      api.reload('3b74c468', component.options)
    }
    module.hot.accept("./InfoTitle.vue?vue&type=template&id=3b74c468&", function () {
      api.rerender('3b74c468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchPointInfo/InfoTitle.vue"
export default component.exports